export default __webpack_public_path__ + "static/media/trike_summer.e5c888df.webp";